import { Icon } from '@petsmart-ui/sparky';
import Highlighter from 'react-highlight-words';

import type { SearchSuggestionItem } from '../../../search.types';

type SuggestionResultProps = {
    item: SearchSuggestionItem;
};

export function SuggestionResult({ item }: Readonly<SuggestionResultProps>) {
    const decodedLabel = decodeURIComponent(encodeURI(item.label));

    return (
        <div className="header-search__suggestion">
            <Icon
                className="header-search__suggestion-icon"
                name={item.kind === 'recent' ? 'clock-outline' : 'search'}
                aria-hidden="true"
            />
            <div className="header-search__suggestion-main">
                <span className="header-search__suggestion-name">
                    <Highlighter
                        highlightClassName="header-search__text--normal"
                        unhighlightClassName={
                            item.highlight.matchLevel === 'none'
                                ? 'header-search__text--normal'
                                : 'header-search__text--highlighted'
                        }
                        searchWords={[...item.highlight.matchedWords]}
                        textToHighlight={decodedLabel}
                    />
                </span>
                {item.category && !item.category.includes('+') && (
                    <span className="header-search__suggestion-category">— in {item.category}</span>
                )}
            </div>
        </div>
    );
}
